import React from 'react';
import styled from 'styled-components';
import { color, gutter } from '../../styles/mixins';
import { m24 } from '../../styles/typography';

const Host = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 0;

  border-bottom: 1px solid ${color('gray30')};
  margin-bottom: ${gutter(3.5)};
`;

const Title = styled.div`
  ${m24};
`;

const Close = styled.div``;

interface SheetHeaderProps {
  title: string;
  children: React.ReactNode;
}

export const SheetHeader = ({ title, children }: SheetHeaderProps) => {
  return (
    <Host>
      <Title>{title}</Title>
      <Close>{children}</Close>
    </Host>
  );
};
